var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iv-remote-wrapper"},[_c('Tree',{attrs:{"data":_vm.data,"disableCheckbox":""},on:{"on-select-change":_vm.handleCheckChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }